// APP-WIDE theme (light / dark), shared by the whole B2C app.
//
// Why this exists: the toggle used to live inside Dashboard and set
// `data-bos-theme` on <html> only while the dashboard was mounted — its cleanup
// REMOVED the attribute on unmount. So navigating to the website stripped the
// theme, and the marketing site + chat could never be dark. This lifts the theme
// to the app root: the attribute is set once, persists across navigation, and one
// toggle themes everything (website, chat, and dashboard all read the same tokens).

import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const THEME_KEY = 'bosTheme';          // kept: same storage key the dashboard used
const ThemeCtx = createContext(null);

export function AppThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    const saved = localStorage.getItem(THEME_KEY);
    return saved === 'light' || saved === 'dark' ? saved : 'light';   // light is the default; users can toggle to dark
  });

  // Stamp the attribute on <html> for the whole session — NO cleanup that removes
  // it, so the choice survives leaving any single screen.
  useEffect(() => {
    document.documentElement.setAttribute('data-bos-theme', theme);
    localStorage.setItem(THEME_KEY, theme);
  }, [theme]);

  const toggle = useCallback(() => setTheme((t) => (t === 'dark' ? 'light' : 'dark')), []);

  return <ThemeCtx.Provider value={{ theme, setTheme, toggle }}>{children}</ThemeCtx.Provider>;
}

export function useAppTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) throw new Error('useAppTheme must be used within AppThemeProvider');
  return ctx;
}
